import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import { fetchApi } from '../../services/apiService';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";

const BranchAutocomplete = forwardRef((props, ref) => {
    const { allOption = false, selectedValues = [], prevId, nextId, editMode = false, isFormikFormField = false, showGstNo = false, showFormError = false,
        isCompulsory = false, singleSelect = true, label = "Branch", searchPlaceholder = "Search By Branch Name",
        noDataLabel = "No Branch Found", width = '100%', listWidth = width, disabled = false,
        ...rest } = props;
    let branchOptions = [];
    if (allOption) {
        branchOptions.push({ branchName: 'All Branches', branchId: '' });
    }
    let initialProps = {
        ...rest,
        labelKey: !showGstNo ? 'branchName' : 'branchWithGstNo',
        primaryKey: 'branchId',
        options: branchOptions,
        isObject: true,
        isFormikFormField,
        showFormError,
        isCompulsory,
        singleSelect,
        label,
        searchPlaceholder,
        noDataLabel,
        width,
        listWidth,
        dataLoaded: false,
        editMode,
        prevId,
        nextId,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getBranchOptions = async () => {
            const getBranchParams = {};
            const response = await fetchApi('masters/getBranches', getBranchParams, userToken);
            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption) {
                    newOptions.push({ branchName: 'All Branches', branchId: '' });
                }
                if (response.data.branches.length > 0) {
                    newOptions = newOptions.concat(response.data.branches);
                }
                if (newOptions.length > 0) {
                    newOptions = newOptions.map((s) => {
                        if (s.gstNo !== "" || null) {
                            return { ...s, branchWithGstNo: s.branchName + ' GST No - ' + s.gstNo }
                        } else {
                            return { ...s, branchWithGstNo: s.branchName }
                        }
                    })
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((b) => selectedValues.indexOf(b.branchId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getBranchOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(editMode){
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = defaultProps.options.filter((b) => selectedValues.indexOf(b.branchId) >= 0);
            }
            setDefaultProps({ ...defaultProps, editMode, preSelectedValues, dataLoaded: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMode, selectedValues]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((i) => selectedValues.indexOf(i.branchId) >= 0);
        }
        setDefaultProps({ ...defaultProps, nextId, prevId, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextId, prevId]);

    useEffect(() => {
        let preSelectedValues = [];
        if (selectedValues.length > 0) {
            preSelectedValues = defaultProps.options.filter((i) => selectedValues.indexOf(i.branchId) >= 0);
        }
        setDefaultProps({ ...defaultProps, disabled, preSelectedValues, dataLoaded: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);

    return ( defaultProps.dataLoaded || editMode ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            />
        : <></>
    );
});

export default BranchAutocomplete;